import {customElement, LitElement, property, html as _} from "lit-element";
import {UiService} from "@kta20-ui-base/services/ui-service";

const functionalStyles = 'height: 98%; width: 98%; padding: 2%; border:none';
const longTextStyles = `ion-textarea textarea {height: 98%; width: 98%; padding: 2%; border:none;}`;

@customElement(UiLongTextInputView.TAG_NAME)
export class UiLongTextInputView extends LitElement {

    static TAG_NAME = 'kta20-ui-long-text-input-view'

    @property({ type: String })
    value:string;

    @property({ type: String })
    title:string;

    @property({ type: String })
    buttonLabel:string;

    @property({ type: String })
    placeholder:string;

    @property({ type: Number })
    minlength:Number;

    @property({ type: Number })
    maxlength:Number;

    readonly renderRoot:Element | ShadowRoot;

    constructor(useShadow:boolean=false){
        super();
        this.renderRoot = useShadow ? this.shadowRoot : this;
    }

    async connectedCallback() {
        super.connectedCallback();

        await this.updateComplete;

        //doesn't work without timeout due to
        //the animation running on modal display
        setTimeout(()=>{
            this.querySelector('textarea').focus();
        },700);
    }

    protected createRenderRoot(): Element | ShadowRoot {
        return this.renderRoot;
    }

    protected render() {
        return _`
        <style>${longTextStyles}</style>
        <ion-header>
        <ion-toolbar mode="ios">
            <ion-buttons slot="end">
              <ion-button @click="${()=> UiService.get().dismissModal({ignore:true})}">
                <ion-icon name="close"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>
              ${this.title}
            </ion-title>
          </ion-toolbar>
        </ion-header>    
        <ion-content>
            <ion-textarea 
                autofocus
                placeholder="${this.placeholder}"  
                value="${(this.value) ? this.value : ''}"
                @ionChange="${(ev)=>{ this.value = ev.target.value }}"
                minlength="${this.minlength}"
                maxlength="${this.maxlength}" 
                style="${functionalStyles}"></ion-textarea>
        </ion-content>
        <ion-footer>
              <ion-button @click="${()=> UiService.get().dismissModal({value:this.value})}" expand="full">
                ${this.buttonLabel}
                </ion-button>
        </ion-footer>
        `;
    }
}
